// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CreateDataGroupRequest {
    'systemCode': string;
    'systemId': string;
    'overwrite'?: boolean;
    'body'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CreateDataGroupRequest>> = [
        {
            "name":     "systemCode",
            "baseName": "systemCode",
            "type":     "string"
        },
        {
            "name":     "systemId",
            "baseName": "systemId",
            "type":     "string"
        },
        {
            "name":     "overwrite",
            "baseName": "overwrite",
            "type":     "boolean"
        },
        {
            "name":     "body",
            "baseName": "body",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return CreateDataGroupRequest.attributeTypeMap;
    }
}
